const useInfinityScroll = ({ entities, totalCount, rowsCount, onLoadMore, loading }) => {
  const stubSize = Math.ceil(rowsCount / 2.4);
  const isLoadMore = entities.length < totalCount;
  const rowCount = isLoadMore ? entities.length + stubSize : entities.length;
  const loadMoreRows = loading || !isLoadMore ? () => {} : onLoadMore;
  const isRowLoaded = index => Boolean(entities[index]);

  return {
    rowCount,
    loadMoreRows,
    isRowLoaded,
  };
};

export default useInfinityScroll;
